// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1-M2N","file":"styles_file__3vtZI"};